import { createSentryPiniaPlugin } from "@sentry/vue";
import { createPinia } from "pinia";
import persistence from "pinia-plugin-persistedstate";

const pinia = createPinia();

pinia.use(persistence);
pinia.use(createSentryPiniaPlugin());

export default pinia;
